<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ TipoCliente.tclId ? 'Alterar tipo de cliente' : 'Novo tipo de cliente' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de tipos de
                                cliente</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ TipoCliente.tclId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-account-details-outline</v-icon></span>
                                <div>
                                    <h4>{{ TipoCliente.tclId ? 'Alterar tipo de cliente' : 'Novo tipo de cliente' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="TipoCliente.tclId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="TipoCliente.tclNome" :rules="nameRules" :counter="100"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="TipoCliente.tclVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="TipoCliente.tclAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="TipoCliente.tclId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de tipos de cliente</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headers" :items="TipoClientes" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-tclVisivel="item">
                                        <span>{{ item.tclVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tclAtivo="item">
                                        <span>{{ item.tclAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
export default {
  name: 'CadastroTipoClienteView',
  components: {
    EasyDataTable
  },
  data: () => ({
    EditView: false,
    TipoCliente: {
      tclId: 0,
      tclNome: '',
      tclVisivel: '',
      tclAtivo: ''
    },
    TipoClientes: [],
    selectedVisivel: null,
    headers: [
      { text: 'Id', value: 'tclId', sortable: true },
      { text: 'Nome', value: 'tclNome', sortable: true },
      { text: 'Visivel', value: 'tclVisivel', sortable: true },
      { text: 'Ativo', value: 'tclAtivo', sortable: true },
      { text: 'Ações', value: 'actions' }
    ],
    itemsSelected: [],
    selectedItem: null,
    searchValue: ''
  }),
  methods: {
    // edit
    EditNew () {
      this.EditView = true
      this.TipoCliente.tclId = 0
      this.TipoCliente.tclNome = ''
      this.TipoCliente.tclVisivel = ''
      this.TipoCliente.tclAtivo = ''
    },
    EditGrid (item) {
      this.EditView = true
      if (item.tclId != '') {
        axios.get('/Telas/ClienteTipo/GetById/' + item.tclId)
          .then(response => {
            this.TipoCliente = response.data
          })
      }
    },
    EditCancel () {
      // window.location.reload();
      this.$router.go(0)
    },
    Add () {
      if (this.TipoCliente.tclNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.TipoCliente.tclVisivel === '') {
        this.$mensagemAviso('Visível Obrigatório.')
      } else if (this.TipoCliente.tclAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        axios.post('/Telas/ClienteTipo/Add', this.TipoCliente)
          .then(response => {
            if (response.data > 0) {
              this.$mensagemAvisoSucesso('Registro Incluído.')
              this.Get()
            }
          })
      }
    },
    Put () {
      if (this.TipoCliente.tclNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.TipoCliente.tclVisivel === '') {
        this.$mensagemAviso('Visível Obrigatório.')
      } else if (this.TipoCliente.tclAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        axios.put('/Telas/ClienteTipo/Update', this.TipoCliente)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Registro Alterado.')
              this.Get()
            }
          })
      }
    },
    // edit
    DeleteGrid (item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            const param1 = item.tclId
            axios.delete(`/Telas/ClienteTipo/Delete/${param1}`)
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Registro Excluido.')
                  this.Get()
                }
              })
          }
        })
    },
    Get () {
      this.EditView = false
      axios.get('/Telas/ClienteTipo/GetAll')
        .then(response => {
          this.TipoClientes = response.data
        })
    }
  },
  created () {
    this.Get()
  }
}
</script>

<style></style>
